import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)


export default new Vuex.Store({
    state: {
        portfolios : [
            {
                id : 'reucirs',
                number : 1,
                logo : 'logo-reucirs.png',
                alt: 'logo reucirs',
                link: '/portfolios/reucirs',
                header : 'REUCIRS est un cabinet spécialisé dans l’accompagnement et le conseil en financement de la recherche et de l’innovation',
                descriptionTitle : 'Site Internet Vitrine',
                lists : [ 'Wordpress' , 'Responsive', 'SEO & Optimisation'],
                linkWeb : 'https://www.reucirs.fr/',
                mockup : 'mockup-reucirs.png',
                bg : 'bg-reucirs.jpg'
            },
            {
                id: 'jmcars',
                number : 2,
                logo : 'logo-jmcars.png',
                alt: 'logo jmcars',
                link: '/portfolios/jmcars',
                header : 'JM CARS propose des expériences uniques afin que vous puissiez expérimenter l’art de vivre à la française.',
                description : 'Site Internet E-Commerce',
                lists : [ 'Wordpress' , 'Responsive', 'Back Office', 'SEO & Optimisation', 'Module de réservation sur mesure'],
                linkWeb : null,
                mockup : 'mockup-jmcars.png',
                bg : 'bg-jmcars.jpg'
            },
            {
                id: 'allyon',
                number : 3,
                logo : 'logo-allyon.png',
                alt: 'logo allyon',
                link: '/portfolios/allyon',
                header : 'ALLYON développe et vend des produits et solutions innovantes pour la chirurgie orthopédique et du rachis.',
                description : 'Site Internet Vitrine',
                lists : [ 'Wordpress' , 'Responsive', 'SEO & Optimisation'],
                linkWeb : null,
                mockup : 'mockup-allyon.png',
                bg : 'bg-allyon.jpg'
            },
            {
                id: 'jarod',
                number : 4,
                logo : 'logo-jarod.png',
                alt: 'logo jarod',
                link: '/portfolios/jarod-pi',
                header : 'Exclusivité et respect des êtres vivants, JAROD-PI représente la mode durable de demain. Des pièces limitées et numérotées, respectueuses de l\'environnement.',
                description : 'Site Internet E-commerce',
                lists : [ 'Woocommerce' , 'Responsive', 'SEO & Optimisation'],
                linkWeb : 'https://www.jarod-pi.com/',
                mockup : 'mockup-jarod.png',
                bg : 'bg-jarod.jpg'
            },
            {
                id: 'noraker',
                number : 5,
                logo : 'logo-noraker.png',
                alt: 'logo noraker',
                link: '/portfolios/noraker',
                header : 'NORAKER est spécialisée dans la conception, la fabrication et la commercialisation de dispositifs médicaux implantables à base de biomatériaux synthétiques et résorbables pour la substitution osseuse et l’ostéosynthèse.',
                description : 'Site Internet Vitrine',
                lists : [ 'Wordpress' , 'Responsive', 'SEO & Optimisation', 'Espace sécurisé'],
                linkWeb : 'http://noraker.com/',
                mockup : 'mockup-noraker.png',
                bg : 'bg-noraker.jpg'
            },
            {
                id: 'safe',
                logo : 'logo-safe.png',
                number : 6,
                alt: 'logo safe orthopaedics',
                link: '/portfolios/safe-orthopaedics',
                header : 'SAFE ORTHOPAEDICS développe des technologies pour optimiser tous les aspects de l’environnement de soins de santé actuel',
                description : 'Site Internet Vitrine',
                lists : [ 'Wordpress' , 'Responsive', 'SEO & Optimisation'],
                linkWeb : 'https://www.safeorthopaedics.com',
                mockup : 'mockup-safe.png',
                bg : 'bg-safe.jpg'
            },
            {
                id: 'vactec',
                logo : 'logo-vactec.png',
                number : 7,
                alt: 'logo vactec',
                link: '/portfolios/vactec',
                header : 'VACTEC exploite et comercialise un système de protection incendie complet approuvé FM',
                description : 'Site Internet Vitrine',
                lists : [ 'Wordpress' , 'Responsive', 'SEO & Optimisation'],
                linkWeb : 'https://vactecsprinkler.com/',
                mockup : 'mockup-vactec.png',
                bg : 'bg-vactec.jpg'
            },
            {
                id: 'aktid',
                logo : 'logo-aktid.png',
                number : 8,
                alt: 'logo aktid',
                link: '/portfolios/aktid',
                header : 'AKTID conçoit et réalise des solutions de tri et de valorisation de déchets clé en main.',
                description : 'Application web sur mesure',
                lists : [ 'From scratch' , 'Responsive', 'Backoffice', 'Développement sur mesure'],
                linkWeb : 'http://extranet.aktid.fr',
                mockup : 'mockup-aktid.png',
                bg : 'bg-aktid.jpg'
            },
            {
                id: 'ixxo',
                logo : 'logo-ixxo.png',
                number : 9,
                alt: 'logo ixxo wheel',
                link: '/portfolios/ixxo-wheel',
                header : 'IXXO WHEEL propose des produits afin de rendre le démontage et le remontage d\'une roue arrière ou avant de moto facile et rapide.',
                description : 'Site internet E-commerce',
                lists : [ 'Woocommerce' , 'Responsive', 'SEO & Optimisation'],
                linkWeb : 'https://www.ixxowheel.com/',
                mockup : 'mockup-ixxo.png',
                bg : 'bg-ixxo.jpg'
            },
            {
                id: 'essae',
                logo : 'logo-essae.png',
                number : 10,
                alt: 'logo essae',
                link: '/portfolios/essae',
                header : 'L\'Institut ESSAE propose des formations aux salariés et dirigeants afin d\'être bien dans sa vie professionnelle au quotidien.',
                description : 'Site Internet E-commerce',
                lists : [ 'Wordpress' , 'Responsive', 'SEO & Optimisation', 'Woocommerce', 'Modules sur mesure'],
                linkWeb : 'https://essae.fr/',
                mockup : 'mockup-essae.png',
                bg : 'bg-essae.jpg'
            },
            {
                id: 'fineheart',
                logo : 'logo-fineheart.png',
                number : 11,
                alt: 'logo fineheart',
                link: '/portfolios/fineheart',
                header : 'FINEHEART a développé ICOMS: une thérapie révolutionnaire pour l’assistance circulatoire à long terme destinée aux patients souffrant d’insuffisance cardiaque grave.',
                description : 'Site Internet Vitrine',
                lists : [ 'Wordpress' , 'Responsive', 'SEO & Optimisation'],
                linkWeb : null,
                mockup : 'mockup-fineheart.png',
                bg : 'bg-fineheart.jpg'
            },
            {
                id: 'tetra',
                logo : 'logo-tetra.png',
                number : 12,
                alt: 'logo tetra',
                link: '/portfolios/tetra-medical',
                header : 'Le Laboratoire TETRA MEDICAL est un des acteurs majeurs de la fabrication et de la commercialisation de compresses, pansements et dispositifs médicaux à usage unique.',
                description : 'Site Internet Vitrine',
                lists : [ 'Wordpress' , 'Responsive', 'SEO & Optimisation'],
                linkWeb : null,
                mockup : 'mockup-tetra.png',
                bg : 'bg-tetra.jpg'
            },
            {
                id: 'marjonat',
                logo : 'logo-marjonat.png',
                number : 13,
                alt: 'logo marjonat',
                link: '/portfolios/marjonat-distribution',
                header : 'MARJONAT DISTRIBUTION propose une solution de régie publicitaire implantée directement dans les magasins pour permettre aux annonceurs de communiquer directement aux shoppers.',
                description : 'Site Internet Vitrine',
                lists : [ 'Wordpress' , 'Responsive', 'SEO & Optimisation'],
                linkWeb : 'https://www.marjonatdistribution.fr/',
                mockup : 'mockup-marjonat.png',
                bg : 'bg-marjonat.jpg'
            },
            {
                id: 'synchro',
                logo : 'logo-synchro.png',
                number : 14,
                alt: 'logo synchro',
                link: '/portfolios/synchro-medical',
                header : 'SYNCHROMEDICAL est une entreprise française qui conçoit et commercialise des dispositifs médicaux orthopédiques pour la chirurgie des extrémités.',
                description : 'Site Internet Vitrine',
                lists : [ 'Wordpress' , 'Responsive', 'SEO & Optimisation', 'Gestion de compte'],
                linkWeb : 'https://synchro-medical.com/',
                mockup : 'mockup-synchro.png',
                bg : 'bg-synchro.jpg'
            },
            {
                id: 'newclip',
                logo : 'logo-newclip.png',
                number : 15,
                alt: 'logo newclip',
                link: '/portfolios/newclip-technics',
                header : 'NEWCLIP TECHNICS conçoit, fabrique et commercialise des implants d’ostéosynthèse destinés à la chirurgie réglée ou à la traumatologie.',
                description : 'Application web sur mesure',
                lists : [ 'From scratch' , 'Responsive', 'Backoffice', 'Développement sur mesure'],
                linkWeb : null,
                mockup : 'mockup-newclip.png',
                bg : 'bg-newclip.jpg'
            },
            {
                id: 'fnadepape',
                logo : 'logo-fnadepape.png',
                number : 16,
                alt: 'logo fnadepape',
                link: '/portfolios/fnadepape',
                header : 'La FNADEPAPE regroupe des Associations Départementales d’Entraide pour les pupilles de l\'Etat et les personnes admises à l’Aide Sociale à l’Enfance.',
                description : 'Application web sur mesure',
                lists : [ 'Wordpress' , 'Responsive', 'SEO & Optimisation'],
                linkWeb : 'https://fnadepape.org/',
                mockup : 'mockup-fnadepape.png',
                bg : 'bg-fnadepape.jpg'
            },
            {
                id: 'appac',
                logo : 'logo_appac.png',
                number : 17,
                alt: 'logo appac',
                link: '/portfolios/appac',
                header : 'La plateforme de Webinars pour l\'APPAC présente une édition digitale d\'un congrès dont la version physique avait été annulée à cause de la Covid-19. Notre solution permet la gestion des vidéos de cet événement virtuel ainsi que la mesure de statistiques.',
                description : 'Application web sur mesure',
                lists : [ 'Plateforme web sur mesure' , 'From scratch', 'Backoffice', 'Espace sécurisé'],
                linkWeb : 'https://appac.net/',
                mockup : 'mockup_appac.png',
                bg : 'bg_appac.jpg'
            },
            {
                id: 'attax',
                logo : 'logo_attax.png',
                number : 18,
                alt: 'logo attax',
                link: '/portfolios/attax',
                header : 'ATTAX est une société industrielle innovante spécialisée dans la conception et la production de systèmes de verrous pour l\'industrie aéronautique.',
                description : 'Site Internet Vitrine',
                lists : [ 'Wordpress', 'Responsive',  'SEO & Optimisation', 'Module sur mesure'],
                linkWeb : 'https://www.attax.com/',
                mockup : 'mockup_attax.png',
                bg : 'bg_attax.jpg'
            },
            {
                id: 'igs',
                logo : 'logo_igs.png',
                number : 19,
                alt: 'logo igs',
                link: '/portfolios/igs',
                header : 'La plateforme IGS permet de créer et d\'assurer le suivi de formations. Elle se concentre sur l\'apprenant et son ressenti lors de la formation.',
                description : 'Application web sur mesure',
                lists : [ 'Plateforme web sur mesure', 'From scratch', 'Backoffice', 'Espace sécurisé'],
                linkWeb : null,
                mockup : 'mockup_IGS.png',
                bg : 'bg_igs.jpg'
            },
            {
                id: 'backbone',
                logo : 'logo_backbone.png',
                number : 20,
                alt: 'logo backbone',
                link: '/portfolios/backbone',
                header : 'BACKBONE conçoit, développe, fabrique et commercialise des dispositifs médicaux implantables pour la chirurgie du rachis.',
                description : 'Site Internet Vitrine',
                lists : [ 'Wordpress', 'Responsive',  'SEO & Optimisation'],
                linkWeb : 'https://www.backbone.pro/',
                mockup : 'mockup_backbone.png',
                bg : 'bg_backbone.jpg'
            },
            {
                id: 'i2b',
                logo : 'logo-i2b.png',
                number : 21,
                alt: 'logo i2b',
                link: '/portfolios/in2bones',
                header : 'IN2BONES est pionner de l\'usage unique pour le pied et la cheville.',
                description : 'Site Internet Vitrine',
                lists : [ 'Wordpress', 'Responsive',  'SEO & Optimisation', 'Espace membre'],
                linkWeb : 'https://in2bones.eu/',
                mockup : 'mockup_i2b.png',
                bg : 'bg_i2b.jpg'
            },
            {
                id: 'og',
                logo : 'logo_og.png',
                number : 22,
                alt: 'logo Opera Groupe',
                link: '/portfolios/opera-groupe',
                header : 'OPERA GROUPE réalise des états des lieux et diagnostics immobiliers pour les professionnels et les particuliers sur toute la France.',
                description : 'Site Internet Vitrine',
                lists : [ 'Wordpress', 'Responsive',  'SEO & Optimisation', 'Module sur mesure de diagnostics'],
                linkWeb : 'https://www.opera-groupe.fr/',
                mockup : 'mockup_OG.png',
                bg : 'bg_og.jpg'
            },
            {
                id: 'remedex',
                logo : 'logo_remedex.png',
                number : 23,
                alt: 'logo remedex',
                link: '/portfolios/remedex',
                header : 'La plateforme REMEDEX permet de suivre l\'évolution des pathologies des patients suite à des injections.',
                description : 'Application web sur mesure',
                lists : [ 'Plateforme web sur mesure' , 'From scratch', 'Backoffice', 'Espace sécurisé'],
                linkWeb : null,
                mockup : 'mockup_remedex.png',
                bg : 'bg_remedex.jpg'
            },
            {
                id: 'tourdelisle',
                logo : 'logo_tdl.png',
                number : 24,
                alt: 'logo tour de lisle',
                link: '/portfolios/tour-de-lisle',
                header : 'TOUR DE L\'ISLE propose dans leur cave à vins de L’Isle sur la Sorgue, une gamme de vins authentique et homogène.',
                description : 'Site Internet Vitrine',
                lists : [ 'Wordpress', 'Responsive',  'SEO & Optimisation', 'Woocommerce'],
                linkWeb : 'https://www.tourdelisle.com/',
                mockup : 'mockup_tourdelisle.png',
                bg : 'bg_tdl.jpg'
            },

        ]
    },
    mutations: {

    },
    actions: {
  
    },
    getters: {
        getPortfolios : state => {
            return state.portfolios
        },
        getOnePortfolio : (state) => (id) => {
            return state.portfolios.find(item => item.id === id)
        }
    }
})